// Wrapper around the presentational BottomSheetView.
//
// The design system ships BottomSheetView (takes paddingBottomClassName as a
// prop, no app coupling). This wrapper keeps the original app-facing API and
// supplies the ad padding so existing call-sites don't change.
import React from "react";

import { BottomSheetView, SheetHeaderConfig } from "./BottomSheetView";

export { ActionItem } from "./BottomSheetView";

export interface BottomSheetProps {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  className?: string;
  /** See BottomSheetView: draws the sheet's header row above the content. */
  header?: SheetHeaderConfig;
  /**
   * Set false when the sheet renders its own sticky footer, which reserves the
   * ad height itself. Reserving in both places leaves the container's padding
   * showing below the footer as a gap.
   */
  reserveAdSpace?: boolean;
}

export const BottomSheet: React.FC<BottomSheetProps> = ({
  children,
  isOpen,
  onClose,
  className,
  reserveAdSpace = true,
  header,
}) => {
  return (
    <BottomSheetView
      isOpen={isOpen}
      onClose={onClose}
      className={className}
      header={header}
      paddingBottomClassName={reserveAdSpace ? "ad-gutter-pad" : undefined}
    >
      {children}
    </BottomSheetView>
  );
};

export default BottomSheet;
